











import { Component, Vue, Emit, Prop } from "vue-property-decorator";

@Component({})
export default class KeywordInput extends Vue {
  @Prop({ type: String, default: "" }) keyword!: string;

  @Emit("update:keyword")
  updateKeyword(event: any) {
    // XXXX
    return event.target.value;
  }
  @Emit("onEnter")
  onEnter() {}
}
